export const formatFieldKey = (key: string): string => {
  return key
    .replace(/\./g, ' → ')
    .replace(/\d+/g, (match) => `Item ${parseInt(match, 10) + 1}`)
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
